import { getColor, useIsColorDark } from 'utils/colorUtility';

export const getColumnItemProps = (
  item,
  typename,
  bgColor,
  alignDesktop,
  alignMobile,
  colorDark,
  imageDark,
  index,
  marginDesktop,
  marginMobile,
  parentBackgroundColor,
  useCtaParentRouting,
) => {
  switch (typename) {
    case 'ContentfulImage':
      return {
        loading: item?.isHero ? 'eager' : 'lazy',
        style: { bottom: 0, right: 0, height: 'auto' },
        maxWidth: '100%',
        styles: item?.styles2,
        justifyDesktop: alignDesktop,
        justifyMobile: alignMobile,
        marginMobile,
        marginDesktop,
        widthMobile: item?.imageWidthMobile,
        widthDesktop: item?.imageWidthDesktop,
        imageSizes: item?.image?.file?.details?.image,
        className: item?.styles2?.hideOnMobile
          ? 'hideMobile'
          : item?.styles2?.hideOnDesktop
          ? 'hideDesktop'
          : '',
      };
    case 'ContentfulWistiaVideo':
      return {
        dataPosition: 'Column',
        height: 'auto',
        width: '100%',
        labelProps: { theme: colorDark || imageDark ? 'light' : 'dark' },
      };
    case 'ContentfulRichText':
      const richTextBg = item?.styles?.backgroundColor;
      const isBgDark = useIsColorDark(getColor(richTextBg || bgColor || parentBackgroundColor));
      const textColor = item?.color ? item?.color : isBgDark ? 'var(--white)' : null;

      return {
        richText: {
          ...item,
          color: textColor,
          alignmentDesktop: item?.alignmentDesktop || alignDesktop,
          alignmentMobile: item?.alignmentMobile || alignMobile,
          listIcon: item?.listIcon?.image?.file?.url,
        },
      };
    case 'ContentfulInPageFeatures':
      return { index };
    case 'ContentfulCallToAction':
      return { useCtaParentRouting };
  }
};
